import { render, staticRenderFns } from "./TabAdmin.vue?vue&type=template&id=032d773e&scoped=true&"
import script from "./TabAdmin.vue?vue&type=script&lang=js&"
export * from "./TabAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TabAdmin.vue?vue&type=style&index=0&id=032d773e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d773e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContent,VRow,VTab,VTabs})
